export const textToSectionId = (text: string): string => {
    // accept only alphabet
    const cleanedText = text.replace(/[^a-zA-Z\s]/g, '');

    // replace space with underscore
    const underscoredText = cleanedText.replace(/\s+/g, '_');

    // Change all text to lowercase
    const lowercasedText = underscoredText.toLowerCase();

    return lowercasedText;
};
